window.$ = window.jQuery = require("jquery")
import Vue from 'vue'
window.Vue = Vue
window.axios = require('axios')
require("bootstrap")
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

// validar errores AXIOS
window.axios.interceptors.response.use(
    (response) => response,
    (error) => {
        swal('Ocurrió un error inesperado', '', 'error')
        throw error
    }
)
require('./vendor/iconify')
require("./vendor/sweetalert")
require('./vendor/jquery.validate.min')

import StripeHelper from './libs/StripeHelper'
window.StripeHelper = StripeHelper
import dayjs from 'dayjs';
import 'dayjs/locale/es';
dayjs.locale('es');
let utc = require('dayjs/plugin/utc')
dayjs.extend(utc)
window.dayjs = dayjs;

window.MonedaFiltro = (value) => {
    if (value === null || value === undefined || isNaN(value)) {
        return '$0.00'
    }
    if (typeof value !== 'number') {
        value = parseFloat(value)
    }
    var formatter = new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN',
        maximumFractionDigits: 2,
    })
    return formatter.format(value);
    // let moneda = formatter.format(value);
    // let monedaArr = moneda.split(".");
    // if(parseFloat(monedaArr[1]) > 0){
    //     return moneda
    // }
    // return monedaArr[0];
}

import vSelect from 'vue-select'
window.Vue.component('v-select', vSelect)

window.Vue.filter('moneda', function (value) {
    return MonedaFiltro(value)
})


